import { Helmet } from 'react-helmet-async';
import { Box } from '@mui/material';
import { Redirect } from 'react-router-dom';

import DealerRequiredPageShell from 'app/components/ReusableUIComponents/HighLevelComponents/DealerRequiredPageShell';
import { DealerPageHeaderEntityInfo } from 'app/components/ReusableUIComponents/LowLevelComponents/PageHeaderEntityInfo';
import { withResourceProtection } from 'app/components/ReusableUIComponents/HOCs/ResourceProtected/withResourceProtection';
import { CONFIGURE_RESOURCE_NURTURING_PLAN_GENERATOR } from 'app/pages/ConfigurePage/utils/configureResourceIds';

import { useV2DealerRequiredRedirect } from 'app/hooks/useV2DealerRequiredRedirect';

import { NurturingPlanGenerator } from './components/NurturingPlanGenerator';
import { PlanBadges } from './components/PlanBadges';
import { PlanHeaderControls } from './components/PlanHeaderControls';
import { useNurturingPlan } from './hooks/useNurturingPlan';
import { useNurturingPlanGeneratorPage } from './hooks/useNurturingPlanGeneratorPage';

const NurturingPlanGeneratorPage = () => {
  const { isBlocked } = useV2DealerRequiredRedirect();
  const { breadcrumbsList, hasDealer, dealerTitle, dealerId } =
    useNurturingPlanGeneratorPage();
  const ctrl = useNurturingPlan();

  if (isBlocked) {
    return <Redirect to="/configure" push={false} />;
  }

  return (
    <>
      <Helmet>
        <title>Nurturing Plan Generator</title>
        <meta
          name="description"
          content="Generate nurturing plans for the selected dealership"
        />
      </Helmet>
      <Box sx={{ position: 'relative', width: '100%' }}>
        {hasDealer && !ctrl.versionsLoading && !ctrl.showInitialize ? (
          <PlanHeaderControls ctrl={ctrl} />
        ) : null}
        <DealerRequiredPageShell
          hasDealer={hasDealer}
          breadcrumbsList={breadcrumbsList}
          pageTitle="Nurturing Plan Generator"
          headerSubtitle={
            hasDealer ? (
              <DealerPageHeaderEntityInfo
                title={dealerTitle}
                dealerId={dealerId}
              />
            ) : undefined
          }
          headerSubtitleRight={
            hasDealer && !ctrl.versionsLoading && !ctrl.showInitialize ? (
              <PlanBadges plan={ctrl.saving || ctrl.settingsLoading ? null : ctrl.plan} />
            ) : undefined
          }
          contentVariant="fluid"
        >
          <NurturingPlanGenerator ctrl={ctrl} />
        </DealerRequiredPageShell>
      </Box>
    </>
  );
};

export default withResourceProtection(
  NurturingPlanGeneratorPage,
  CONFIGURE_RESOURCE_NURTURING_PLAN_GENERATOR,
);
